export const getCountryFlagEmoji = (countryCode: string): string => {
  if (countryCode.length === 2) {
    const codePoints = countryCode
      .toUpperCase()
      .split("")
      .map(char => char.charCodeAt(0) + 127397)
    return String.fromCodePoint(...codePoints)
  }

  return ""
}
